// extracted by mini-css-extract-plugin
export default {"datatable":"DataTable_datatable__uFGcM"};